

/******************************************************
    Select boxes
******************************************************/
import $ from 'jquery';


export default function initSelect() {
	if ($("select").length) {
		setupSelect();
	}
}


function setupSelect() {
    $('select').not('select-hidden').each(function () {
		var $this = $(this), numberOfOptions = $(this).children('option').length;

		$this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"><span></span></div>');

		var $styledSelect = $this.next('div.select-styled');
		var $styledSelectText = $styledSelect.find('span');
		$styledSelectText.text($this.children('option:selected').text());

		var $list = $('<ul />', {
			'class': 'select-options'
		}).insertAfter($styledSelect);

		for (var i = 0; i < numberOfOptions; i++) {
			$('<li />', {
				text: $this.children('option').eq(i).text(),
				rel: $this.children('option').eq(i).val()
			}).appendTo($list);
		}

		var $listItems = $list.children('li');

		$styledSelect.click(function (e) {
			e.stopPropagation();
			$('div.select-styled.active').not(this).each(function () {
				$(this).removeClass('active').next('ul.select-options').hide();
			});
			$(this).toggleClass('active').next('ul.select-options').toggle();
		});

		$listItems.click(function (e) {
			e.stopPropagation();
			$styledSelectText.text($(this).text()).removeClass('active');
			$this.val($(this).attr('rel')).change();
			$list.hide();
		});

		$(document).click(function () {
			$styledSelect.removeClass('active');
			$list.hide();
		});
	});
}

